import styled from 'styled-components';
import { TableContainer } from '@material-ui/core';

export const Wrapper = styled(TableContainer)``;
